import {Box, Button, Text, Title} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import {type FC, useEffect} from 'react';
import {routes} from '../../../../config/constants';
import {COLOR_LINK_1} from '../../../../config/constants/colorCodes';
import {GSSKT_HOST} from '../../../../config/constants/hosts';

export const LinkPage: FC = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.pathname)}`;
  // クロスサイトリクエストフォージェリ防止用に10文字のランダムな文字列を生成
  const randomString = Math.random().toString(36).slice(2, 10);

  useEffect(() => {
    window?.localStorage.setItem('lineLinkageKey', randomString);
  }, [randomString]);

  return (
    <>
      <Head>
        <title key="title">外資就活ドットコム - スカウトLINE 連携</title>
        <meta key="og:title" property="og:title" content="LINE連携" />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <Title
          order={1}
          className="border-t-4 border-link-1 bg-white p-16 text-lg text-link-1 pc:px-32"
        >
          外資就活ドットコム - スカウトLINE 連携
        </Title>
        <Box
          className=" bg-white px-8 pc:px-32"
          sx={() => ({
            paddingBottom: '16px',
            fontSize: '14px',
            lineHeight: '24px',
          })}
        >
          <Text>
            外資就活ドットコムとLINEを連携します。
            連携すると、企業からスカウトやチャットが届いた際に、LINE上でも通知が届くようになります。
          </Text>
          <Button
            fullWidth
            variant="outline"
            mt={16}
            styles={() => ({
              label: {
                color: COLOR_LINK_1,
              },
              root: {
                borderColor: COLOR_LINK_1,
              },
            })}
            onClick={() => {
              if (
                Boolean(process.env.NEXT_PUBLIC_LINE_LOGIN_CHANNEL_ID) &&
                Boolean(process.env.NEXT_PUBLIC_LINE_LOGIN_REDIRECT_URL)
              ) {
                location.href = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${process.env.NEXT_PUBLIC_LINE_LOGIN_CHANNEL_ID}&redirect_uri=${process.env.NEXT_PUBLIC_LINE_LOGIN_REDIRECT_URL}&state=${randomString}&bot_prompt=aggressive&scope=profile%20openid`;
              }
            }}
          >
            連携する
          </Button>
          <Button
            fullWidth
            variant="light"
            mt={8}
            styles={() => ({
              label: {
                color: COLOR_LINK_1,
              },
            })}
            onClick={() => {
              location.href = routes.HOME;
            }}
          >
            ホームに戻る
          </Button>
        </Box>
      </Box>
    </>
  );
};
